export const VerticalLine38 = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="3" height="38" viewBox="0 0 3 38" fill="none">
            <path opacity="0.8" d="M1.63 0.870117V37.1851" stroke="white" strokeWidth="1.29696" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}